<template lang="pug">
  .set-hrs.modal.component
    vue-cal.cal.vuecal--blue-theme.calendar(
      ref='cal'
      default-view="week"
      :time-step='30'
      :snapToTime='30'
      :disable-views="['years', 'year', 'month','day']"
      :drag-to-create-event='false'
      :time-from='opening'
      :time-to='closing'
      :hide-weekdays='hide'
      :events='closures'
      hide-title-bar
      hide-view-selector
      @cell-click='clicked'
    )
</template>

<script>
  import VueCal from 'vue-cal'

  export default {
    name: 'set-hrs.modal.component',

    components: {
      VueCal
    },

    props: {
      cfg: { type: Object, required: true }
    },

    data() {
      return {
        closures: [],
        mapper: {
          mon: 1,
          tue: 2,
          wed: 3,
          thu: 4,
          fri: 5,
          sat: 6,
          sun: 7
        }
      }
    },

    computed: {
      opening() {
        let dt = new Date( this.cfg.opening )
        return dt.getUTCHours() * 60 + dt.getUTCMinutes()
      },

      closing() {
        let dt = new Date( this.cfg.closing )
        return dt.getUTCHours() * 60 + dt.getUTCMinutes()
      },

      hide() {
        let days = []
        Object.keys( this.cfg.days ).forEach( key  =>  {
          if ( !this.cfg.days[key] ) days.push( this.mapper[key] )
        })
        return days
      }
    },

    methods: {
      clicked( e ) {
        if ( e.getMinutes() >= 30 ) e.setMinutes( 30 )
        else e.setMinutes( 0 )
        
        let start = `${e.getFullYear()}/${String(e.getMonth()+1).padStart(2, 0)}/${String(e.getDate()).padStart(2, 0)} ${String(e.getHours()).padStart(2, 0)}:${String(e.getMinutes()).padStart(2,0)}`
        e.setMinutes( e.getMinutes() + 30 )
        let end = `${e.getFullYear()}/${String(e.getMonth()+1).padStart(2,0)}/${String(e.getDate()).padStart(2,0)} ${String(e.getHours()).padStart(2, 0)}:${String(e.getMinutes()).padStart(2,0)}`
        
        let index = this.closures.findIndex( c => c.start == start )
        if ( index < 0 ) {
          let evt = {
            start,
            end,
            title: 'Closed',
          }
          this.closures.push( evt )
        }
        else {
          // if event exists then remove it from closures enumerable
          this.closures.splice( index, 1 )
        }
      },
    },

    created() {
      this.closures = this.cfg.closures || []
    }
  }
</script>

<style lang="stylus" scoped>
  .set-hrs.modal
    >>> .vuecal__cell-content
      cursor pointer
    
    >>> .weekday-label 
      cursor default
      
    >>> .weekday-label span:last-child
      display none

    >>> .vuecal--week-view, >>> .vuecal--month-view, >>> .vuecal--day-view 	
      border 2px solid grey	
      border-radius 5px	
      background rgb(255 255 255)	
    
    >>> .vuecal__cell--today 
      background rgba(255 255 255 0)

    >>> .vuecal__event
      background rgb( 113 113 113) 

    >>> .vuecal__cell--selected
      background rgba(255 255 255 0)

    >>> .vuecal__no-event	
      display none	
    >>> .vuecal__now-line
      display none
    >>> .vuecal__flex.vuecal__title, >>> .vuecal__flex.weekday-label	
      background rgb(54 131 149)
      color white
      font-weight bold
    >>> .vuecal__time-column
      font-weight bold
      background rgb(54 131 149)
    >>> .vuecal__time-cell
      color white
</style>
